// Sort by string or number or date
export function compare(a: number | string | Date, b: number | string | Date, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}

// transform to rx-select
export function transformSelect(text: string, value: number) {
  return { text: text, value: value };
}
